var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPinIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.313 0c2.943 0 5.645 1.333 7.415 3.657a9.37 9.37 0 0 1 0 11.31l-6.621 8.64a.997.997 0 0 1-1.588 0L4.9 14.97a9.371 9.371 0 0 1-.002-11.313C6.668 1.333 9.369 0 12.313 0zm0 2C10 2 7.878 3.046 6.49 4.868a7.362 7.362 0 0 0 0 8.888l5.822 7.6 5.825-7.603a7.36 7.36 0 0 0-.002-8.885C16.748 3.045 14.626 2 12.313 2zm0 3.289a3.825 3.825 0 0 1 3.821 3.822 3.825 3.825 0 0 1-3.82 3.82 3.825 3.825 0 0 1-3.822-3.82 3.825 3.825 0 0 1 3.821-3.822zm0 2a1.824 1.824 0 0 0-1.82 1.822c0 1.004.816 1.82 1.82 1.82a1.823 1.823 0 0 0 1.821-1.82 1.824 1.824 0 0 0-1.82-1.822z",
    fill: "#448AFF",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinIcon);
export default __webpack_public_path__ + "static/media/pin-icon.bec21df5ae3df3a62922d4d754072678.svg";
export { ForwardRef as ReactComponent };